import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const updateAcademicTitles = (
  prefixed_academic_title: string,
  suffixed_academic_title: string
) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/profiles/profiles`,
    body: {
      profile: {
        prefixed_academic_title,
        suffixed_academic_title,
      },
    },
  });
};

export default updateAcademicTitles;
